/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: hGcTP4LoXXzT

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import CalloutSectionTextColumn from "../../CalloutSectionTextColumn"; // plasmic-import: kp0OkUEgiTwF/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicCalloutSection.module.css"; // plasmic-import: hGcTP4LoXXzT/css

createPlasmicElementProxy;

export type PlasmicCalloutSection__VariantMembers = {};
export type PlasmicCalloutSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicCalloutSection__VariantsArgs;
export const PlasmicCalloutSection__VariantProps = new Array<VariantPropType>();

export type PlasmicCalloutSection__ArgsType = { onContactClick?: () => void };
type ArgPropType = keyof PlasmicCalloutSection__ArgsType;
export const PlasmicCalloutSection__ArgProps = new Array<ArgPropType>(
  "onContactClick"
);

export type PlasmicCalloutSection__OverridesType = {
  calloutSection?: Flex__<"section">;
  desktop?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  tablet?: Flex__<"div">;
  wrapper4?: Flex__<"div">;
  mobile?: Flex__<"div">;
  wrapper3?: Flex__<"div">;
};

export interface DefaultCalloutSectionProps {
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicCalloutSection__RenderFunc(props: {
  variants: PlasmicCalloutSection__VariantsArgs;
  args: PlasmicCalloutSection__ArgsType;
  overrides: PlasmicCalloutSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"calloutSection"}
      data-plasmic-override={overrides.calloutSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.calloutSection
      )}
    >
      <div
        data-plasmic-name={"desktop"}
        data-plasmic-override={overrides.desktop}
        className={classNames(projectcss.all, sty.desktop)}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames(projectcss.all, sty.wrapper)}
        >
          <CalloutSectionTextColumn
            className={classNames(
              "__wab_instance",
              sty.calloutSectionTextColumn__mGMnL
            )}
            onContactClick={args.onContactClick}
          />
        </div>
      </div>
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames(projectcss.all, sty.tablet)}
        >
          <div
            data-plasmic-name={"wrapper4"}
            data-plasmic-override={overrides.wrapper4}
            className={classNames(projectcss.all, sty.wrapper4)}
          >
            <CalloutSectionTextColumn
              className={classNames(
                "__wab_instance",
                sty.calloutSectionTextColumn__wxx4L
              )}
              onContactClick={async () => {
                const $steps = {};

                $steps["runOnContactClick"] = true
                  ? (() => {
                      const actionArgs = { eventRef: $props["onContactClick"] };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runOnContactClick"] != null &&
                  typeof $steps["runOnContactClick"] === "object" &&
                  typeof $steps["runOnContactClick"].then === "function"
                ) {
                  $steps["runOnContactClick"] =
                    await $steps["runOnContactClick"];
                }
              }}
            />
          </div>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames(projectcss.all, sty.mobile)}
        >
          <div
            data-plasmic-name={"wrapper3"}
            data-plasmic-override={overrides.wrapper3}
            className={classNames(projectcss.all, sty.wrapper3)}
          >
            <CalloutSectionTextColumn
              className={classNames(
                "__wab_instance",
                sty.calloutSectionTextColumn__kgZpF
              )}
              onContactClick={async () => {
                const $steps = {};

                $steps["runOnContactClick"] = true
                  ? (() => {
                      const actionArgs = { eventRef: $props["onContactClick"] };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runOnContactClick"] != null &&
                  typeof $steps["runOnContactClick"] === "object" &&
                  typeof $steps["runOnContactClick"].then === "function"
                ) {
                  $steps["runOnContactClick"] =
                    await $steps["runOnContactClick"];
                }
              }}
            />
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  calloutSection: [
    "calloutSection",
    "desktop",
    "wrapper",
    "tablet",
    "wrapper4",
    "mobile",
    "wrapper3"
  ],
  desktop: ["desktop", "wrapper"],
  wrapper: ["wrapper"],
  tablet: ["tablet", "wrapper4"],
  wrapper4: ["wrapper4"],
  mobile: ["mobile", "wrapper3"],
  wrapper3: ["wrapper3"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  calloutSection: "section";
  desktop: "div";
  wrapper: "div";
  tablet: "div";
  wrapper4: "div";
  mobile: "div";
  wrapper3: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCalloutSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCalloutSection__VariantsArgs;
    args?: PlasmicCalloutSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCalloutSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCalloutSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCalloutSection__ArgProps,
          internalVariantPropNames: PlasmicCalloutSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCalloutSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "calloutSection") {
    func.displayName = "PlasmicCalloutSection";
  } else {
    func.displayName = `PlasmicCalloutSection.${nodeName}`;
  }
  return func;
}

export const PlasmicCalloutSection = Object.assign(
  // Top-level PlasmicCalloutSection renders the root element
  makeNodeComponent("calloutSection"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    wrapper: makeNodeComponent("wrapper"),
    tablet: makeNodeComponent("tablet"),
    wrapper4: makeNodeComponent("wrapper4"),
    mobile: makeNodeComponent("mobile"),
    wrapper3: makeNodeComponent("wrapper3"),

    // Metadata about props expected for PlasmicCalloutSection
    internalVariantProps: PlasmicCalloutSection__VariantProps,
    internalArgProps: PlasmicCalloutSection__ArgProps
  }
);

export default PlasmicCalloutSection;
/* prettier-ignore-end */
